import React, { useContext, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Form, Modal, Button } from "react-bootstrap";
import { FluentDatePicker } from '../../../../components/FluentUI/Fluent-DatePicker';
import { FluentProvider } from '@fluentui/react-components';
import { AddMembersAndGroupsToProject, getProjectWithDep } from '../../../../services/api/user-api';
import { GetAssignedUserPermission, ReassignTask } from '../../../../services/api/task-api';
import { LoginContext } from '../../../../services/api/authentication-api';
import { errorNotification, successNotification } from "../../../../redux/notifications";
import TaskAssignMembers from '../../../../components/TaskAssignMember/TaskAssignMembers';
import TaskAssignMembersMultiOwner from '../../../../components/TaskAssignMember/TaskAssignMembersMultiOwner';
import './tasks-reassign-panel.scss';
import "bootstrap/dist/css/bootstrap.min.css";

const TasksReassignPanel = ({
    onHide,
    show,
    setPage,
    taskId,
    taskName,
    createdById,
    taskTitle = "Assigned Members",
    errorFromEdit,
    task,
    currUserId,
    refreshTasks,
}) => {
    const dispatch = useDispatch();
    const context = useContext(LoginContext);
    const labels  = context?.currentUser?.objectLabels;
    const [buttonDisable, setButtonDisable] = useState(true);
    const [taskMembers, setTaskMembers] = useState([]);
    const [taskOtherMembers, setTaskOtherMembers] = useState([])
    const [projectInfo, setProjectInfo] = useState(null);
    const [permissionTaskMembers, setPermissionTaskMembers] = useState([]);
    const [taskAssigned, setTaskAssigned] = useState(false);
    const [assignedMembers, setAssignedMembers] = useState([]);
    const [assignedOwner, setAssignedOwner] = useState({});
    const [assignedOwners, setAssignedOwners] = useState([]);
    const [assignedOtherDepMembers, setAssignedOtherDepMembers] = useState([]);
    const [filterAssignedMembers, setFilterAssignedMembers] = useState([]);
    const [filteredOtherDepMembers, setFilteredOtherDepMembers] = useState([]);
    const [hide, setHide] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [comment, setComment] = useState("");
    const [priority, setPriority] = useState(task?.PriorityId);
    const [due, setDue] = useState(new Date(task?.Due));
    const [errorMessage, setErrorMessage] = useState([]);
    const [ownerAsAGroup, setOwnerAsAGroup] = useState(null);
    const [permissionConditions, setPermissionConditions] = useState({CanChangeApprover : false, CanChangeEditor : false, CanChangeViewer : false, CanChangeOwner : false});
    const [projectIsMultiOwner, setProjectIsMultiOwner] = useState(false);
    const IsMultiOwner = projectIsMultiOwner;
    const TaskAssignMemberComponent = IsMultiOwner ? TaskAssignMembersMultiOwner : TaskAssignMembers;

    useEffect(() => {
        getAllTaskMembers();
        getProjectAdd();
        getGroupOwner();
    }, []);

    useEffect(() => {
      if ((taskMembers?.length || ownerAsAGroup != null) && !taskAssigned) {
        getAllAssignedMembers(taskMembers, taskOtherMembers);
      }
    }, [taskMembers, taskOtherMembers, taskAssigned, ownerAsAGroup]);

    useEffect(() => {
      let obj = {
        WorkflowInstanceId : task?.Workflow?.Id,
        Members : task.Members,
        Groups : task.Groups ?? [],
        CreatedById : task.CreatedById,
      }
      getAssignedUserPermission(obj);
    }, []);

    const getAssignedUserPermission = async (obj) => {
      let result = await GetAssignedUserPermission(obj);
      if (result?.status === 200) {
        setPermissionConditions(result.data);
      }
    }

    const getGroupOwner = () => {
      let temp = task.Groups?.filter(group => {
        if (group.IsOwner) {
          return group;
        }
      })
      if (temp?.length > 0) {
        setOwnerAsAGroup(temp[0]);
      }
    };

    const getAllTaskMembers = async () => {
      if (task.Members?.length || task.Groups?.length) {
        let groups = task.Groups.map((group) => {
          group.Id = group.GroupId;
          group.UserId = group.GroupId;
          group.User = {
            Id: group.GroupId,
          };
          group.IsGroup = true;
          return group;
        });

        let taskMembers =  removeDuplicates(task.Members, "UserId");
        let taskGroups = removeDuplicates(groups, "UserId");
        let allmembers = [...taskMembers, ...taskGroups];
        setTaskMembers(allmembers);
      }
    };

    const getProjectAdd = async () => {
      await getProjectWithDep(task.ProjectId, context).then(
        async result => {
            if (result?.status === 200) {
                setProjectInfo(result.data);
                setProjectIsMultiOwner(result.data.IsMultiOwner ?? false);
                let groups = result.data.Members
                    .filter((group) => group.IsGroup) // Filter for groups
                    .map((group) => {
                        group.Id = group.GroupId;
                        group.UserId = group.GroupId;
                        group.User = {
                            Id: group.GroupId,
                        };
                        group.IsGroup = true;
                        group.IsProjectMember = true;
                        // Guard: Group is null for a soft-deleted group still linked to the project.
                        if (group.Group) {
                            group.Group.IsProjectMember = true;
                        }
                        return group;
                    });
                let newGroups = result.data.Groups.map((group) => {
                    group.Id = group.GroupId;
                    group.UserId = group.GroupId;
                    group.User = {
                        Id: group.GroupId,
                    };
                    group.IsGroup = true;
                    group.IsProjectMember = true;
                    // Guard: Group is null for a soft-deleted group still linked to the project.
                    if (group.Group) {
                        group.Group.IsProjectMember = true;
                    }
                    return group;
                });
                let depMem = result.data.DepMembers.map((member) => {
                    if (result.data.Members.some(m => m.UserId === member.Id)) {
                        member.IsProjectMember = true;
                        return member;
                    }
                    return member;
                });
                var depGroups = result.data.DepGroups.filter((group) => {
                    if (!result.data.Groups.some(m => m.GroupId === group.Id)
                        && !result.data.Members.some(m => m.GroupId === group.Id)) {
                        group.IsGroup = true;
                        return group;
                    }
                });
                let allMembers = [...groups, ...depMem, ...newGroups, ...depGroups];
                setButtonDisable(false);
                setTaskOtherMembers(allMembers);
            } else {
                console.log("API [GetProject] error status: " + result.status);
                setPage("500 error");
            }
        },
        error => {
            console.log("API [GetProject] error ->", error);
            setPage("500 error");
        }
      );
    };

    const removeDuplicates = (originalArray, prop) => {
      let newArray = [];
      let lookupObject = {};
      for (let i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
      }

      for (let i in lookupObject) {
        newArray.push(lookupObject[i]);
      }
      return newArray;
    };

    const onSubmitAllReassignUpdates = async () => {
      setButtonDisable(true);
      const allProjMembers = [...projectInfo?.Members, ...projectInfo?.Groups];
      const addedNewMembers = taskMembers.filter(i => !allProjMembers.find(member => member.UserId === i.UserId && (member.IsGroup ?? false) === (i.IsGroup ?? false)) && !i.IsGroup)
      .map(member => member.UserId);
      const addedNewGroups = taskMembers.filter(i => !allProjMembers.find(member => member.UserId === i.UserId && member.IsGroup == i.IsGroup) && i.IsGroup)
      .map(group => group.UserId);
      let obj ={
          UserIds : addedNewMembers,
          GroupIds : addedNewGroups,
          ProjectId : task.ProjectId
      }

      if (addedNewMembers.length > 0 || addedNewGroups.length > 0) {
          await AddMembersAndGroupsToProject(obj)
              .then(res => {
                  if (res.status == 200) {
                    console.log('res', res);
                  }
              })
              .catch(error => {
                  console.log("Error adding other Member =>");
                  console.log(error);
              })
              .finally(() => onSubmitReassigned());
      } else {
          onSubmitReassigned();
      }
    };

    const getAllAssignedMembers = (assignedMembers, otherProjMembers) => {
      let taskOwner = {};
      let currMembers = [];
      let otherMembers = [];
      let filterMembersNames = [];
      let otherFilterMembersNames = [];
      let permissionMembers = [];
      assignedMembers.forEach(function (member) {
          if (member.UserId === createdById && !member.IsGroup) {
              taskOwner = member.User;
          }
          filterMembersNames.push(member.User.Name);
          currMembers.push({
              ...member.User,
              Id: member.UserId,
              IsGroup: member.IsGroup,
              IsOwner: member.IsOwner,
            });
          permissionMembers.push({
              Id: member.UserId,
              canApprove: member.CanApprove,
              canEdit: member.CanEdit || member.IsAssigned,
              canReassign: member.CanReassign,
              canView: member.CanView,
              IsGroup: member.IsGroup,
              IsOwner: member.IsOwner,
              // Archived/moved assignees are absent from the assignable pool; carry the
              // flag and a render-ready object so the chips can fall back to it (TAD-5898).
              Archived: member.IsGroup ? member.Archived === true : member.User?.Archived === true,
              Member: member.IsGroup
                ? { ...member, Archived: member.Archived === true, Members: member.GroupMembers || [] }
                : member.User,
          });
      });

      otherProjMembers.forEach(function (member) {
          if (member?.Group?.Id > 0) {
            member.Group.IsGroup = true;
            otherMembers.push(member.Group);
            otherFilterMembersNames.push(member.Group.Name);
          } else {
            otherFilterMembersNames.push(member.Name);
            otherMembers.push(member);
          }
      });
      let uniqueMembers = removeDuplicates(currMembers.filter(x => !x.IsGroup), "Id");
      let uniqueGroups = removeDuplicates(currMembers.filter(x => x.IsGroup), "Id");
      let uniqueOtherMembers = removeDuplicates(otherMembers.filter(x => !x.IsGroup), "Id");
      let uniqueOtherGroups = removeDuplicates(otherMembers.filter(x => x.IsGroup), "Id");
      let uniquePermissionMembers = removeDuplicates(permissionMembers.filter(x => !x.IsGroup), "Id");
      let uniquePermissionGroups = removeDuplicates(permissionMembers.filter(x => x.IsGroup), "Id");
      let uniquePermissions = [...uniquePermissionMembers, ...uniquePermissionGroups];
      if (IsMultiOwner) {
          const ownerIds = uniquePermissionMembers
            .filter(p => p.IsOwner)
            .map(p => p.Id);

          const owners = uniqueMembers.filter(member =>
            ownerIds.includes(member.Id)
          );

          setAssignedOwners(owners);
        }
          else {
          setAssignedOwner(taskOwner);
      }
      setAssignedMembers([...uniqueMembers, ...uniqueGroups]);
      setAssignedOtherDepMembers([...uniqueOtherMembers, ...uniqueOtherGroups]);
      setPermissionTaskMembers([...uniquePermissions]);
      setFilterAssignedMembers([...new Set(filterMembersNames)]);
      setFilteredOtherDepMembers([...new Set(otherFilterMembersNames)]);
    };

    const addMembersInForm = (permission, id, isGroup = false) => {
      setErrorMessage("");
      const loweredPermission = permission.toLowerCase();

      const existingIndex = taskMembers.findIndex(
        m => m.UserId === id && (m.IsGroup ?? false) === (isGroup ?? false)
      );

      const isOwnerBeingAdded = loweredPermission === "owner";

      if (existingIndex !== -1) {
        let updated = [...taskMembers];
        const existing = updated[existingIndex];

        if (isOwnerBeingAdded) {
          existing.IsOwner = true;
        } else {
          existing.CanEdit = loweredPermission === "editor";
          existing.IsAssigned = loweredPermission === "editor";
          existing.CanView = loweredPermission === "viewer";
          existing.CanApprove = loweredPermission === "approver";
        }

        updated[existingIndex] = existing;
        setTaskMembers(updated);
        return;
      }

      const newMembers = assignedOtherDepMembers
        .filter(
          m => m.Id === id && (m.IsGroup ?? false) === (isGroup ?? false)
        )
        .map((member) => ({
          ...member,
          UserId: member.Id,
          CanEdit: loweredPermission === "editor",
          IsAssigned: loweredPermission === "editor",
          CanView: loweredPermission === "viewer",
          CanApprove: loweredPermission === "approver",
          IsOwner: loweredPermission === "owner",
        }));

      let tempTaskMembers = [...taskMembers];

      if (isOwnerBeingAdded) {
        const newOwner = assignedOtherDepMembers.find(
          m => m.Id === id && (m.IsGroup ?? false) === (isGroup ?? false)
        );

        if (IsMultiOwner) {
          setAssignedOwners(prev => [...prev, newOwner]);
        } else {
          setAssignedOwner(newOwner);
          tempTaskMembers.forEach(m => {
            if (m.Id !== id && (m.IsGroup ?? false) === (isGroup ?? false)) {
              m.IsOwner = false;
            }
          });
        }
      }

      setTaskMembers([...tempTaskMembers, ...newMembers]);
      setTaskAssigned(true);
    };

    const removeMembersInForm = (permission, id, isGroup = false) => {
      let updatedMembers = [...taskMembers];

      if (IsMultiOwner && permission === "owner") {
        setAssignedOwners(prev => prev.filter(m => m.Id !== id));

        updatedMembers = updatedMembers.map(m => {
          if (m.UserId === id && (m.IsGroup ?? false) === (isGroup ?? false)) {
            return {
              ...m,
              IsOwner: false,
            };
          }
          return m;
        }).filter(m =>
          m.IsOwner || m.CanEdit || m.CanView || m.CanApprove || m.IsAssigned
        );
      } else if (!IsMultiOwner && assignedOwner?.Id === id && !isGroup) {
        updatedMembers.forEach(m => {
          if (m.UserId === id && (m.IsGroup ?? false) === (isGroup ?? false)) {
            m.IsOwner = true;
            m.CanEdit = false;
            m.CanView = false;
            m.CanApprove = false;
            m.IsAssigned = false;
          }
        });
      } else {
        updatedMembers = updatedMembers.map(m => {
          if (m.UserId === id && (m.IsGroup ?? false) === (isGroup ?? false)) {
            return {
              ...m,
              CanEdit: false,
              CanView: false,
              CanApprove: false,
              IsAssigned: false,
            };
          }
          return m;
        }).filter(m =>
          m.IsOwner || m.CanEdit || m.CanView || m.CanApprove || m.IsAssigned
        );
      }

      setTaskMembers(updatedMembers);
      setErrorMessage("");
    };

    const onBrowseFilesLoaded = convertedFiles => {
      let files = selectedFiles;

      if (files.length === 0) {
        files = convertedFiles;
      } else {
        let fileFound = false;
        convertedFiles.forEach(file => {
          for (let matchingFile of files) {
            if (matchingFile.name === file.name) {
              fileFound = true;
              break;
            }
          }
          if (!fileFound) {
            files.push(file);
          }
        });
      }
      setSelectedFiles([...files]);
    };

    const onSubmitReassigned = async () => {
        let reassignRequest = {
          Id: task.Id,
          allApprovers: task.AllApprovers,
          Comments: [
            { TaskId: task.Id, Note: comment, ActionId: "5", Files: selectedFiles }
          ],
          taskType: task.TaskType,
          Priority:
            priority == 1 ? "Low" :
            priority == 2 ? "Medium" :
            priority == 3 ? "High" : "Urgent",
          Due: due,
          IsMultiOwner: IsMultiOwner,
          ProjectId: task.ProjectId,
          ProjectParentTemplateId: projectInfo?.ParentTemplateId ?? task?.Project?.ParentTemplateId ?? null,
        };

        let hasEditor = false;
        let ownersWithoutAnyPermission = [];

        const ownerIds = IsMultiOwner
          ? assignedOwners.map(o => o.Id)
          : [assignedOwner.Id];

        taskMembers.forEach(member => {
          if (member.CanEdit || member.IsAssigned) {
            hasEditor = true;
          }

          if (
            ownerIds.includes(member.UserId) &&
            !member.CanEdit &&
            !member.IsAssigned &&
            !member.CanView &&
            !member.CanApprove
          ) {
            ownersWithoutAnyPermission.push(member);
          }
        });

        if (!hasEditor && ownersWithoutAnyPermission.length === 0 && ownerAsAGroup == null) {
          setErrorMessage(`Unable to Re-Assign ${labels?.TaskSingular ?? "Task"}: Must have at least 1 editor`);
          setButtonDisable(false);
          return;
        }

        if (!hasEditor && ownersWithoutAnyPermission.length > 0 && ownerAsAGroup == null) {
          ownersWithoutAnyPermission.forEach(m => {
            m.CanEdit = true;
            m.IsAssigned = true;
          });
        }

        reassignRequest.CreatedById = IsMultiOwner ? ownerIds[0] : assignedOwner.Id;

        reassignRequest.Members = taskMembers.filter(m =>
          (ownerIds.includes(m.UserId) && ownerAsAGroup == null) ||
          m.CanView || m.CanApprove || m.CanEdit || m.IsAssigned || m.IsOwner
        );

        await ReassignTask(reassignRequest).then(
          result => {
            dispatch(successNotification({
              header: `Re-Assign ${labels?.TaskSingular ?? "Task"}`,
              message: `${task.Name} Re-Assigned successfully`,
            }));
            setButtonDisable(false);
            onHide();
            refreshTasks();
          },
          error => {
            setButtonDisable(false);
            dispatch(errorNotification({
              header: `Re-Assign ${labels?.TaskSingular ?? "Task"}`,
              message: `Unable to Re-Assign ${task.Name}`,
            }));
          }
        );
      };

    const errorMessageDisplay = (message) => {
      return (
        message !== "" && (
          <Form.Label>
            <div type="invalid" className="error-message-assign">
              {message}
            </div>
          </Form.Label>
        )
      );
    };

    const reassignedMembersTable = (
      <Form.Group data-testid="selectedMembers">
        <div className="loginInput">
          {taskTitle}<i className="red">*</i>
        </div>
        <FluentProvider>
        {
          <TaskAssignMemberComponent
            assignedMembers={assignedOtherDepMembers}
            assignedOwner={IsMultiOwner? assignedOwners : assignedOwner}
            filteredAssignedMembers={filteredOtherDepMembers}
            addMembersInForm={addMembersInForm}
            removeMembersInForm={removeMembersInForm}
            permissionTaskMembers={permissionTaskMembers}
            task={task}
            currUserId={currUserId}
            ownerGroup={ownerAsAGroup}
            CanChangeApprover={permissionConditions.CanChangeApprover}
            CanChangeEditor={permissionConditions.CanChangeEditor}
            CanChangeViewer={permissionConditions.CanChangeViewer}
            CanChangeOwner={permissionConditions.CanChangeOwner}
          />
        }
        </FluentProvider>
        {
            errorMessageDisplay(errorMessage)
        }
      </Form.Group>
    );

    const showReassignedMembersContent = () => {
      return (
        <div onClick={(e) => e.stopPropagation()}>
          <Modal
            show={show}
            onHide={onHide}
            className="tasks-reassign-popup"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title className="actions-title">
                Re-Assign {labels?.TaskSingular ?? 'Task'}
              </Modal.Title>
            </Modal.Header>
            <div className="select-member-divider-line"></div>
            <Modal.Body>
              <div className="reassign-modal-body">
                <h3 className="reassign-task-name">{task.Name}</h3>
                <div>
                  <div className="properties-container">
                    <div className="reassign-left-panel">
                      <Form.Group>
                        <Form.Label>Comments (optional)</Form.Label>
                        <Form.Control
                          value={comment}
                          onChange={(e) => {
                            setComment(e.target.value);
                          }}
                          as="textarea"
                          rows="3"
                          placeholder="Enter Comment"
                        />
                      </Form.Group>
                    </div>
                    <div className="reassign-right-panel">
                      <Form.Group className="due-date-calendar">
                        <Form.Label>Due Date</Form.Label>
                        <FluentDatePicker
                          id="dtDueDate"
                          name="dtDueDate"
                          placeholder="Click to select a end date"
                          value={due}
                          onChange={(value) => {
                            if (value) value.setUTCHours(23, 59, 59, 0);
                            setDue(value);
                          }}
                          minDate={new Date()}
                          maxDate={Date.parse(task?.Project?.End) ?? new Date()}
                        />
                      </Form.Group>
                      <Form.Group className="priority-dropdown">
                        <Form.Label>Priority</Form.Label>
                        <Form.Control
                          name="priority"
                          value={priority}
                          onChange={(e) => {
                            setPriority(e.target.value);
                          }}
                          as="select"
                        >
                          <option value="1">Low</option>
                          <option value="2">Medium</option>
                          <option value="3">High</option>
                          <option value="4">Urgent</option>
                        </Form.Control>
                      </Form.Group>
                    </div>
                  </div>
                  {reassignedMembersTable}
                  <div className="action-btns">
                    <Button
                      className="btn-wide btn-outlined"
                      onClick={onHide}
                      variant="primary"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={onSubmitAllReassignUpdates}
                      className="btn-wide"
                      variant="primary"
                      disabled={buttonDisable}
                    >
                      Re-Assign {labels?.TaskSingular ?? 'Task'}
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      );
    };

    return (
      <div>
        {!hide &&
          <React.Fragment>
            {showReassignedMembersContent()}
          </React.Fragment>
        }
      </div>
    );
};

TasksReassignPanel.propTypes = {
    onHide: PropTypes.func.isRequired,
    show: PropTypes.bool,
    setPage: PropTypes.func,
    taskId: PropTypes.number,
    taskName: PropTypes.string,
    createdById: PropTypes.number,
    taskTitle: PropTypes.string,
    errorFromEdit: PropTypes.any,
    task: PropTypes.object.isRequired,
    currUserId: PropTypes.number,
    refreshTasks: PropTypes.func.isRequired,
};

export default TasksReassignPanel;
